// React Components
import * as React from 'react';

// Material UI Components
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionActions from '@mui/material/AccordionActions';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Audit Vault Components
import ProgressBar from "../common/ProgressBar";


export default function RoleInfoList(props) {

    // Component Constants
    const { 
      tenantId, 
      handleAccordionLoad,
      handleReviewMembers,
      handleAddMembers,
      handleRemoveAccess,
      acccordianExpand,
      roleName,
      roleDescription,
      roleId,
      loading,
      users
     } = props;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };



// Component UI
return(
    <Accordion expanded={acccordianExpand}>
        <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        onClick={event => handleAccordionLoad(roleId) } 
        id="panel1a-header"
        >
        <Typography><b>{roleName}</b><br/>{roleDescription}</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <ProgressBar message="Loading ..." loading={loading} />

        <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
            <Table stickyHeader size="small" aria-label="lifecycle coordinators table">
                <TableBody>
                    {users
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            return (
                                <TableRow key={`LC-${row.displayName}-${row.id}`}>
                                    <TableCell
                                        sx={{
                                            wordBreak: 'break-word',
                                            fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                        }}
                                    >
                                        <Tooltip title={row.userEmail} arrow>
                                            <span>{row.displayName}</span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{ width: 60, whiteSpace: 'nowrap' }}
                                    >
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => handleRemoveAccess(roleId, row.microsoftUserId)}
                                            size="small"
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </TableContainer>
        {users.length > 25 &&
        <TablePagination
                  rowsPerPageOptions={[25, 50, 75]}
                  component="span"
                  count={users.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage} />
        }
        </AccordionDetails>
        <AccordionActions>
            <Typography component="span" sx={{width:'100%'}}>
            <Button size="small" variant="outlined" sx={{textAlign: "left"}} onClick={(event) => handleReviewMembers(roleId)}>View members</Button>
            </Typography>
            <IconButton sx={{textAlign: "right"}} aria-label="addUser" onClick={(event) => handleAddMembers(roleId)}>
                <PersonAddAlt1Icon sx={{ color: "green" }} />
            </IconButton>
        </AccordionActions>
    </Accordion>
)
}
